export async function MejorateCreate( 
    metaFecha,
    mejorateTipo,
    mejorateCompleted,
    mejorateStep,
    mejoratePoint,
    tratamientoId,
    pacienteId
     ) {
    const formData = {
        title: `us-${pacienteId}-tr-${tratamientoId}-mejorate-${metaFecha}`,
        slug: `us-${pacienteId}-tr-${tratamientoId}-mejorate-${metaFecha}`,
        status: "publish",
        tratamiento: tratamientoId,
        paciente: pacienteId,
        meta: {
            metaFecha: metaFecha,
            metaPaciente: pacienteId,
            mejorateTipo: mejorateTipo,
            mejorateCompleted: mejorateCompleted,
            mejorateStep: mejorateStep,
            mejoratePoint: mejoratePoint,
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/mejorate', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}

export async function MejorateUpdate(
    metaFecha,
    mejorateTipo,
    mejorateCompleted,
    mejorateStep,
    mejoratePoint,
    tratamientoId,
    pacienteId,
    mejorateId ) {
    const formData = {
        title: `us-${pacienteId}-tr-${tratamientoId}-mejorate-${metaFecha}`,
        slug: `us-${pacienteId}-tr-${tratamientoId}-mejorate-${metaFecha}`,
        status: "publish",
        tratamiento: tratamientoId,
        paciente: pacienteId,
        meta: {
            metaFecha: metaFecha,
            metaPaciente: pacienteId,
            mejorateTipo: mejorateTipo,
            mejorateCompleted: mejorateCompleted,
            mejorateStep: mejorateStep,
            mejoratePoint: mejoratePoint,
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/mejorate/${mejorateId}`, {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}


export async function MejorateDraft(
    metaFecha,
    tratamientoId,
    pacienteId,
    mejorateTipo
  ) {
    const formData = {
      title: `us-${pacienteId}-tr-${tratamientoId}-mejorate-${metaFecha}`,
      slug: `us-${pacienteId}-tr-${tratamientoId}-mejorate-${metaFecha}`,
      status: "draft",
      tratamiento: tratamientoId,
      author: pacienteId,
      paciente: pacienteId,
      meta: {
        metaFecha: metaFecha,
        metaPaciente: pacienteId,
        mejorateTipo: mejorateTipo,
      },
    };
  
    const authToken = sessionStorage.getItem( 'token' );
  
    try {
      const response = await fetch(
        "https://app.tavad.com/hce/wp-json/wp/v2/mejorate",
        {
          method: "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${ authToken }`,
          },
          body: JSON.stringify(formData),
        }
      );
      const values = await response.json();
      console.log(values);
      return values;
    } catch (error) {
      console.error(error);
    }
  }
  
  export async function MejorateSchedule(
    metaFecha,
    tratamientoId,
    pacienteId,
    scheduledDate,
    mejorateTipo
  ) {
    const formData = {
      title: `us-${pacienteId}-tr-${tratamientoId}-mejorate-${metaFecha}`,
      slug: `us-${pacienteId}-tr-${tratamientoId}-mejorate-${metaFecha}`,
      status: "future",
      tratamiento: tratamientoId,
      author: pacienteId,
      paciente: pacienteId,
      date: scheduledDate,
      meta: {
        metaFecha: metaFecha,
        metaPaciente: pacienteId,
        mejorateTipo: mejorateTipo,
      },
    };
  
    const authToken = sessionStorage.getItem( 'token' );
  
    try {
      const response = await fetch(
        "https://app.tavad.com/hce/wp-json/wp/v2/mejorate",
        {
          method: "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${ authToken }`,
          },
          body: JSON.stringify(formData),
        }
      );
      const values = await response.json();
      console.log(values);
      return values;
    } catch (error) {
      console.error(error);
    }
  }